module.exports = __webpack_public_path__ + "66705cad69bd370c2f619a2253f24c4b.pdf";